import React, { useEffect } from 'react';
import AddExamResult from '@components/exam_result/AddExamResult';
import {
  resetToDefaultNavbarState,
  setNavbarWithTitleNoTopNavbar,
} from '@atom/navbarAtom';

const AddExamResultPage = () => {
  useEffect(() => {
    setNavbarWithTitleNoTopNavbar('Add Exam Results');

    return () => {
      resetToDefaultNavbarState();
    };
  }, []);

  return <AddExamResult />;
};

export default AddExamResultPage;
